<template>
    <div class="name mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="poster_name != '' ? 'border-primary' : ''" type="text" id="inputName"
                v-model="poster_name"
                @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': poster_name != ''
                }">Tên người đăng</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            poster_name: ''
        }
    },
    watch: {
        data(val){
            this.poster_name = val;
        },
        poster_name(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.poster_name = this.data;
    }
}
</script>
